<corely-layout class="w-full" />
